import { useCallback, useEffect, useState } from 'react';
import { latestReads } from '../../live/useLive';
import { useTasksChanged } from './useTasks';

/**
 * The sidebar's Tasks badge (10/9/26) - the main tab's tasks only, so it
 * lives apart from the scope-aware useTasks.js: how many open tasks are mine - owned
 * or tagged on, every type, as the Dashboard's My tasks card counts them.
 * Re-read when any task changes (useTasksChanged). Off (0) for people
 * without the Tasks area, and when the read fails.
 */
export function useMyOpenTaskCount(enabled) {
  const [count, setCount] = useState(0);
  const [reads] = useState(latestReads);
  const load = useCallback(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    const ticket = reads.start();
    fetch('/api/crm-actions?owner=me&status=open')
      .then((r) => (r.ok ? r.json() : null))
      .then((rows) => {
        if (reads.show(ticket) && Array.isArray(rows)) setCount(rows.length);
      })
      .catch(() => {});
  }, [enabled, reads]);
  useEffect(load, [load]);
  useTasksChanged(load);
  return count;
}
